export default {
    "en": {
        "All_FAQ_Body_Title1": "How Can We Help?",
        "All_FAQ_Body_Title1_Description1": "Search for articles...",
        "All_FAQ_tab1_Title1": "Frequently Asked Questions",
        "All_FAQ_tab2_Title1": "Contact us",
        "All_FAQ_Body_Title1_Button1": "Can't find your answer?",
        "All_FAQ_Body_Title1_Description2": "Search results for:",
        "All_FAQ_Body_Title2": "Contact Customer Support",
        "All_FAQ_Body_Title2_Subtitle1": "Email address",
        "All_FAQ_Body_Title2_Subtitle2": "Subject",
        "All_FAQ_Body_Title2_Subtitle2_Description1": "Let us know how we can help you.",
        "All_FAQ_Body_Title2_Subtitle3": "Full Description",
        "All_FAQ_Body_Title2_Subtitle3_Description1": "Please include as much information as possible.",
        "All_FAQ_Body_Title2_Button1": "Send",
        "All_FAQ_Body_Title1_Description3": "No results were found for your search.",
        "All_FAQ_Body_Title2_Description1": "*Please enter your details.",
        "All_FAQ_Body_Title2_Description2": "*the format of the e-mail address is wrong"
    },
    "ko": {
        "All_FAQ_Body_Title1": "어떻게 도와드릴까요?",
        "All_FAQ_Body_Title1_Description1": "도움말 검색",
        "All_FAQ_tab1_Title1": "자주하는 질문",
        "All_FAQ_tab2_Title1": "문의하기",
        "All_FAQ_Body_Title1_Button1": "원하는 답변을 찾지 못하셨나요?",
        "All_FAQ_Body_Title1_Description2": "검색 결과:",
        "All_FAQ_Body_Title2": "고객센터에 문의하기",
        "All_FAQ_Body_Title2_Subtitle1": "답변받을 이메일 주소",
        "All_FAQ_Body_Title2_Subtitle2": "제목",
        "All_FAQ_Body_Title2_Subtitle2_Description1": "문의할 내용에 대한 주제를 써주세요.",
        "All_FAQ_Body_Title2_Subtitle3": "내용",
        "All_FAQ_Body_Title2_Subtitle3_Description1": "문의내용을 가능한 상세히 써주세요.",
        "All_FAQ_Body_Title2_Button1": "작성한 문의내용 보내기",
        "All_FAQ_Body_Title1_Description3": "검색 결과가 없습니다.",
        "All_FAQ_Body_Title2_Description1": "*내용을 입력해주세요.",
        "All_FAQ_Body_Title2_Description2": "*이메일 주소 형식이 잘못되었습니다"
    },
    "cn": {
        "All_FAQ_Body_Title1": "需要帮助？",
        "All_FAQ_Body_Title1_Description1": "搜索文章......",
        "All_FAQ_tab1_Title1": "常见问题",
        "All_FAQ_tab2_Title1": "联系我们",
        "All_FAQ_Body_Title1_Button1": "找不到您的答案？",
        "All_FAQ_Body_Title1_Description2": "搜索结果:",
        "All_FAQ_Body_Title2": "联系客服",
        "All_FAQ_Body_Title2_Subtitle1": "接收回复的电子邮件地址",
        "All_FAQ_Body_Title2_Subtitle2": "主题",
        "All_FAQ_Body_Title2_Subtitle2_Description1": "如您需要帮忙，请联系我们。",
        "All_FAQ_Body_Title2_Subtitle3": "详细描述",
        "All_FAQ_Body_Title2_Subtitle3_Description1": "请尽可能多地提供相关信息。",
        "All_FAQ_Body_Title2_Button1": "发送",
        "All_FAQ_Body_Title1_Description3": "找不到与您的搜索相关的结果。",
        "All_FAQ_Body_Title2_Description1": "*请填写所有字段以发送您的消息。",
        "All_FAQ_Body_Title2_Description2": "*电子邮箱格式错误"
    },
    "ja": {
        "All_FAQ_Body_Title1": "お困りですか？",
        "All_FAQ_Body_Title1_Description1": "ヘルプの検索",
        "All_FAQ_tab1_Title1": "よくある質問",
        "All_FAQ_tab2_Title1": "お問い合わせ",
        "All_FAQ_Body_Title1_Button1": "ヘルプを見ても解決しない場合",
        "All_FAQ_Body_Title1_Description2": "検索結果：",
        "All_FAQ_Body_Title2": "カスタマーサービスにお問い合わせ",
        "All_FAQ_Body_Title2_Subtitle1": "返信用メールアドレス",
        "All_FAQ_Body_Title2_Subtitle2": "タイトル",
        "All_FAQ_Body_Title2_Subtitle2_Description1": "お問い合わせ内容のタイトルをご記入ください。",
        "All_FAQ_Body_Title2_Subtitle3": "内容",
        "All_FAQ_Body_Title2_Subtitle3_Description1": "お問い合わせ内容をできるだけ詳しくご記入ください。",
        "All_FAQ_Body_Title2_Button1": "お問い合わせを送信",
        "All_FAQ_Body_Title1_Description3": "検索結果がありません。",
        "All_FAQ_Body_Title2_Description1": "お問い合わせ内容を送信するには、全ての項目に記入してください。",
        "All_FAQ_Body_Title2_Description2": "*メールアドレスの形式が正しくありません"
    }
}


// WEBPACK FOOTER //
// ./src/text/help/laptop.js